import { createRegionsClient } from '@pay-roadrunner/regions-ui';
import { createTaxConfigurationClient, TaxConfigurationScreen } from '@pay-roadrunner/tax-configuration-ui';
import { createTenantPayTypesClient } from '@pay-roadrunner/pay-types-ui';
import { authFetch } from '../auth/authFetch';
import { getApiBaseUrl } from '../auth/api';
import { TabbedItemPage } from './TabbedItemPage';
import { PayTypesCatalogueScreen } from '../features/payTypes/PayTypesCatalogueScreen';
import { BsbDirectoryScreen } from '../features/bsbDirectory/BsbDirectoryScreen';
import { PayClassificationsScreen } from '../features/payClassifications/PayClassificationsScreen';
import './ConfigurationPage.css';

const apiClientDeps = { getBaseUrl: getApiBaseUrl, fetchImpl: authFetch };
const regionsClient = createRegionsClient(apiClientDeps);
const taxConfigurationClient = createTaxConfigurationClient(apiClientDeps);
const payTypesClient = createTenantPayTypesClient(apiClientDeps);

const payTypesPanelHostId = 'configuration-pay-types-panel';

export const ConfigurationPage = () => {
  const [payTypesPanelOpen, setPayTypesPanelOpen] = useState(false);

  return <TabbedItemPage
    itemPath="/maintenance/configuration"
    className={`configuration-page${payTypesPanelOpen ? ' configuration-page--panel-open' : ''}`}
    aside={<div id={payTypesPanelHostId} className="configuration-page__detail-host" />}
    tabIcons={{ 'pay-types': 'attachment' }}
    tabContentOverrides={{
      'awards-and-classifications': <PayClassificationsScreen />,
      tax: <TaxConfigurationScreen regionsClient={regionsClient} taxConfigurationClient={taxConfigurationClient} />,
      'pay-types': <PayTypesCatalogueScreen client={payTypesClient} panelHostId={payTypesPanelHostId} onPanelVisibilityChange={setPayTypesPanelOpen} />,
      banking: <BsbDirectoryScreen />,
    }}
  />;
};
import { useState } from 'react';
